import DeckGL from '@deck.gl/react';
import { PickInfo } from 'deck.gl';
import { MapMarkerType } from '../../../store/mst/models';

const queryRouteLayer = (deckRef: DeckGL, picked: PickInfo<MapMarkerType>, layerIds: string[]) => {
  if (deckRef !== null) {
    const routeLayers = deckRef.pickMultipleObjects({
      x: picked.x,
      y: picked.y,
      radius: 10,
      layerIds,
    });

    return routeLayers && routeLayers.length > 0 ? routeLayers[0] : null;
  }

  return null;
};

export default queryRouteLayer;
